import http from "../config/HttpCommon";

const InboxService = (data) => {
    return http.requestPost(data, `/addEntry`);
};
export default InboxService;